export enum TargetTypes {
	DaysOut = 1,
	GrossProfit = 2,
	CandidateUse = 3,
	ClientUse = 4,
	HoursOut = 5,
	ClientUtilisation = 6,
}
